//@ts-nocheck
import React, { memo } from "react";
import Image from "next/image";
import Link from "next/link";

import styles from "./ContactsContainer.module.scss";

import { PageWrapper, RecomendedQuests, TextComponent } from "components";

import {
  descriptionTexts,
  mainContactsInfo,
  socialIcons,
} from "customTexts/ContactsPageTexts";

const ContactPage = (props: any) => {
  return (
    <>
      <PageWrapper>
        <div className={styles.Wrapper}>
          <TextComponent
            page="contacts"
            title="Контакты"
            descriptionTexts="Компания OLD MOUSE имеет 7 локаций, расположенных в городе Минск."
            isContactsBlock
          />

          <div className={styles.ContactInfoBlock}>
            <div className={styles.ContactInfoBlockText}>
              {mainContactsInfo.map((item, i) => (
                <Link key={item.icon + i} href={item.href}>
                  <div key={item.icon} className={styles.ContactInfoBlockItem}>
                    <Image
                      src={`/icons/${item.icon}`}
                      alt="icon"
                      width={25}
                      height={25}
                    />
                    <span>{item.text}</span>
                  </div>
                </Link>
              ))}
            </div>

            <div className={styles.IframeMap}>
              <img
                className="image-map"
                src={`/images/map.png`}
                alt="icon"
              />
              {/* <iframe
                src="https://yandex.ru/map-widget/v1/?um=constructor%3A6838088bbc4138c6e8a80c2ea396659bc11c54d10110a4860b0a24cc41e0da6f&amp;source=constructo"
                width="100%"
                height="100%"
                frameBorder="0"
              /> */}
            </div>
          </div>

          <div className="flex flex-col mt-10 mb-6">
            <h1 className={styles.PhotoTitle}>Проведите фотосессию мечты</h1>
            <span className={styles.PhotoDescription}>
              Фотосессия в завораживающих декорациях квест-комнат: в атмосферном
              помещении можно снимать фото и видео. Вы можете выбрать любой
              квест из представленных на сайте. Съемка в крутом квесте "Молчание
              ягнят", "Техасская резня бензопилой", "Гарри Поттер", "Сокровище
              дракона" — с Old Mouse возможно все.
            </span>
          </div>
        </div>
      </PageWrapper>
      <RecomendedQuests {...props} />
    </>
  );
};

export default memo(ContactPage);
